import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Amplify } from 'aws-amplify';
import { BrowserRouter } from 'react-router-dom';

const userPoolId = process.env.REACT_APP_USER_POOL_ID;
const userPoolClientId = process.env.REACT_APP_USER_POOL_CLIENT_ID;

if (!userPoolId || !userPoolClientId) {
  // Sign-in is the only thing that breaks without these, so warn loudly rather
  // than blocking the whole site from rendering.
  console.error(
    'REACT_APP_USER_POOL_ID / REACT_APP_USER_POOL_CLIENT_ID are missing from .env — ' +
      'authentication will not work. Restart `npm start` after adding them.'
  );
} else {
  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId,
        userPoolClientId,
      },
    },
  });
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
